// userDataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api";

export const fetchEarnedLeave = createAsyncThunk("earnedLeave/fetchEarnedLeave", async () => {
  const response = await api.post("/earned-leaves");
  return response.data.data;
});

export const addEarnedLeave = createAsyncThunk(
  "earnedLeave/addEarnedLeave",
  async (earnedLeaveData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-earnedLeave", earnedLeaveData);
      dispatch(fetchEarnedLeave());
      dispatch(closeEarnedLeaveModal());
      return response.data.message;  // Assuming success message is in the response data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to save Earned Leave record");
    }
  }
);


export const deleteEarnedLeave = createAsyncThunk(
  "bonus/deleteEarnedLeave",
  async (bonusId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-bonus/${bonusId}`);
      dispatch(fetchEarnedLeave());
      return response.data.message;  
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete bonus record");
    }
  }
);

// Slice
const earnedLeaveSlice = createSlice({
  name: "earnedLeaveData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,  // To store success messages from backend
  },
  reducers: {
    openEarnedLeaveModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeEarnedLeaveModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;  
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;  
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEarnedLeave.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEarnedLeave.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchEarnedLeave.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addEarnedLeave.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addEarnedLeave.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addEarnedLeave.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteEarnedLeave.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteEarnedLeave.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteEarnedLeave.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openEarnedLeaveModal, closeEarnedLeaveModal, clearError } = earnedLeaveSlice.actions;
export default earnedLeaveSlice.reducer;
export { earnedLeaveSlice };
